<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
  <div>
    <div class="pc_me_side card">
      <div class="user_wrap">
        <div class="cover_wrap">
          <div class="cover image"
            v-lazy:background-image="{
              src: $store.state.loginUser.avatar,
              error: './static/img/img_blank.png'
            }" 
          ></div>
        </div>
        <div class="title_wrap">
          <div class="title">
            <span>{{$store.state.loginUser.nickname}}</span>
            <span>ID:{{$store.state.loginUser.id}}</span>
          </div>
          <!-- 我的勋章 -->
          <div class="medal_num_area" @click="goToMedal">
            <span class="medal_icon"  v-lazy:background-image="{
                src: './static/img/medal_1.png',
                error: './static/img/medal_1.png'
              }"></span>
            <span>共<span class="num">{{myMedal}}</span>个勋章</span>
            <van-icon name="arrow"  size="14" class="arrow" v-if="myMedal>0"/>
          </div>
          <div class="list_badges">
            <div class="item_badges" @click="getSelectOrgData()">
              <span>{{$store.state.loginUser.code_name}}</span>
              <span class="qh">[ 切换 ]</span>
            </div>
          </div>
        </div>
        <div class="list_info">
          <router-link class="item_info" :to="{name: 'MyPoint'}">
            <div class="num">{{myPoint}}</div>
            <div class="text">学分</div>
          </router-link>
          <router-link class="item_info" :to="{name: 'Mycertificate'}">
            <div class="num">{{mycertificate}}</div>
            <div class="text">证书</div>
          </router-link>
        </div>
      </div>

      <div class="list_nav">
        <router-link class="item_nav" :class="{active: innerShowActive==1}" :to="{name: 'MySelfstudy'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="todo-list-o" size="20" color="#25345A" />
            <!-- <van-badge :content="10"> -->
              <div class="name">
                <span>我的课程</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==2}" :to="{name: 'MyTrain'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="orders-o" size="20" color="#25345A" />
            <!-- <van-badge :content="6"> -->
              <div class="name">
                <span>我的培训</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==15}" :to="{name: 'MySpecial'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="award-o" size="20" color="#25345A" />
            <!-- <van-badge :content="6"> -->
              <div class="name">
                <span>我的专项认证</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==3}" :to="{name: 'MyLive'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="video-o" size="20" color="#25345A" />
            <!-- <van-badge :content="1"> -->
              <div class="name">
                <span>我的直播</span>
              </div> 
            <!-- </van-badge>  -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <!-- <router-link class="item_nav" :class="{active: innerShowActive==4}" :to="{name: 'MyLearningMap'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="location-o" size="20" color="#25345A" />
              <div class="name">
                <span>学习地图</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link> -->
        <router-link class="item_nav" :class="{active: innerShowActive==5}" :to="{name: 'Order'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="balance-list-o" size="20" color="#25345A" />
              <div class="name">
                <span>我的订单</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==6}" :to="{name: 'MyFav'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="like-o" size="20" color="#25345A" />
            <!-- <van-badge :content="16"> -->
              <div class="name">
                <span>我的收藏</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==7}" :to="{name: 'Myexamination'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="records" size="20" color="#25345A" />
            <!-- <van-badge :content="22"> -->
              <div class="name">
                <span>我的考试</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==8}" :to="{name: 'MyArticle'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="label-o" size="20" color="#25345A" />
            
              <div class="name">
                <span>我的干货</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <router-link class="item_nav" :class="{active: innerShowActive==9}" :to="{name: 'MyProblem'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="question-o" size="20" color="#25345A" />
            <!-- <van-badge :content="5"> -->
              <div class="name">
                <span>我的问答</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>

        <router-link class="item_nav" :class="{active: innerShowActive==22}" :to="{name: 'MyAddress'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="location-o" size="20" color="#25345A" />
              <div class="name">
                <span>我的地址</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>

        <router-link class="item_nav" :class="{active: innerShowActive==14}" :to="{name: 'MyReply'}" v-if="$store.state.loginUser.is_teacher==1">
          <div class="nav_wrap">
            <van-icon class="icon" name="certificate" size="20" color="#25345A" />
            <!-- <van-badge :content="5"> -->
              <div class="name">
                <span>我的回复</span>
              </div> 
            <!-- </van-badge> -->
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <div class="item_nav_solid"></div>
        <router-link class="item_nav" :class="{active: innerShowActive==10}" :to="{name: 'MyStudent'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="user-o" size="20" color="#25345A" />
            
              <div class="name">
                <span>我的学员</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        
        <router-link class="item_nav" :class="{active: innerShowActive==20}" :to="{name: 'OverCertificate'}">
          <div class="nav_wrap">
            <!-- <van-icon class="icon" name="coupon-o" size="20" color="#25345A" /> -->
              <div style="width: 20px;height: 20px;line-height: 0px;">
                <img src="../assets/img/card.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="name">
                <span>到期证书</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>

        <!-- OverCertificate -->
        <!-- <router-link class="item_nav" :class="{active: innerShowActive==11}" :to="{name: 'MyStatistics'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="bar-chart-o" size="20" color="#25345A" />
            <div class="name">
              <span>学员统计</span> 
            </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link> -->
        <!-- <router-link class="item_nav" :class="{active: innerShowActive==12}" :to="{name: 'Me'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="notes-o" size="20" color="#25345A" />
            <div class="name">
              <span>培训项目</span> 
            </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link> -->
        <router-link class="item_nav" :class="{active: innerShowActive==16}" :to="{name: 'MyCard'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="user-o" size="20" color="#25345A" />
            
              <div class="name">
                <span>我的卡券</span>
              </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
        <!-- 新增我的卡券 -->
       
        <router-link class="item_nav" :class="{active: innerShowActive==13}" :to="{name: 'Myprofile'}">
          <div class="nav_wrap">
            <van-icon class="icon" name="setting-o" size="20" color="#25345A" />
            <div class="name">
              <span>个人设置</span> 
            </div> 
          </div>
          <van-icon class="right_icon" name="arrow" size="20" color="#ffffff" />
        </router-link>
      </div>

      <div class="btn_box">
        <div class="btn btn_color_1 btn_shadow" @click="btn_loginout">
          退出登录
        </div>
      </div>
    </div>


    <!-- 用户角色信息切换 开始 -->
    <div class="userdata_content" v-if="selectUserType">
      <div class="mask"></div>
      <div class="userdata_wrap">
        <div class="titles">切换组织身份</div>
        <div class="list_user">
          <div class="item_user" :class="{active: item.is_choose==1}" v-for="(item, index) in UserList" :key="index" @click="choose_userdata(item)">
            <i class="material-icons icon" v-if="item.is_choose==0">&#xe40c;</i>
            <i class="material-icons icon" v-else>&#xe39e;</i>
            <div class="title_wrap">
              <span class="title">{{item.name}}</span>
              <span class="badges" v-if="item.natureCode!='store'">[ {{item.parent_name?item.parent_name:'--'}} ]</span>
              <span class="badges" v-else>[ {{item.natureName?item.natureName:'--'}} ]</span>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <div class="btn btn_color_4 btn_shadow" @click="selectUserType=false">取消</div>
          <div class="btn btn_color_1 btn_shadow" @click="btn_choose_user">确认</div>
        </div>
      </div>
    </div>
    <!-- 用户角色信息切换 结束 -->
  </div>
</template>

<script>

export default {
  name: 'PageMe',
  components: {},
  props: ['showActive'],
  data () {
    return {
      tmpName: 'PageNav',
      fixedHeader: false,//控制头部滚动浮动样式
      innerShowActive: 0,

      myPoint: 0,
      mycertificate: 0,
      myMedal:0,
      //登录角色信息
      UserList: [],
      selectUserType: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;

    //是否显示【active】
    if( typeof _this.showActive != 'undefined' ){
      _this.innerShowActive = _this.showActive;
    }

    if(!_this.$store.state.IS_COMPUTER){
      _this.getmypoint();
      _this.getmycertificate();
      _this.getmyMedal()
    }
  },
  mounted() {
  },
  destroyed() {},
  methods: {
    //获取登录身份
    getSelectOrgData(){
      const _this = this;
      
      _this.axios
      .post(
        _this.$store.state.api.gra_api + "login/selectOrgData",
        _this.qs.stringify({
          token: _this.$store.state.loginUser.sessionkey
        })
      )
      .then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("载入登录角色信息失败：接口异常");

              return false;
            }
          }
          if (res.data.status == 1) {

            _this.UserList = res.data.data;
            _this.selectUserType = true;
            
          }else if(res.data.status == 2){
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '当前账号已在其他设备登录',
              message: _this.$store.state.browser.giantopoapp?'如需继续操作，返回后请重新打开GRA':'请重新登录',
              showCancelButton: false,
              confirmButtonText: _this.$store.state.browser.giantopoapp?'我知道了':'前往登录',
            }).then(() => {
              if( _this.$store.state.browser.giantopoapp  ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: location.href } })
              }
            }).catch(() => {
            });
          } else {

            _this.$toast.fail(
              res.data.msg ? res.data.msg : "载入登录角色信息失败：出现了一些问题"
            );
          }
        } else {

          _this.$toast.fail("载入登录角色信息失败：网络加载失败，请稍候再试");
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        } else  {
          _this.$toast.fail("载入登录角色信息失败");
        }
        
        console.error(error);
      });
    },

    //切换组织身份
    choose_userdata(tmp_data) {
      const _this = this;

      _this.UserList.forEach(function(item, index){
        if( tmp_data.org_id == item.org_id ){
          item.is_choose = 1;
        }else{
          item.is_choose = 0;
        }
      })
    },

    //确认选择组织身份
    btn_choose_user(){
      const _this = this;

      let userinfo = {};
      let _type = 1;

      _this.UserList.forEach(function(item, index){
        if( item.is_choose == 1 ){
          userinfo = item;
          _type = 0;
        }
      });

      if( _type == 1 ){
        _this.$toast.fail('请选择需要的组织身份登录');
        return false;
      }

      _this.axios.post(_this.$store.state.api.gra_api + 'login/doSelectOrgData', _this.qs.stringify({
        org_id: userinfo.org_id,
        user_id: _this.$store.state.loginUser.id,
        token: _this.$store.state.loginUser.sessionkey
      })).then(function(res){
        if( res.status == 200 ){
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("提交失败：接口异常");
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fetch_data = res.data.data;

            let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));
            
            loginuser_data.usercode = fetch_data.code;
            loginuser_data.code_name = fetch_data.code_name;

            loginuser_data.user_type = fetch_data.user_type;
            loginuser_data.shopno = fetch_data.shopno;
            loginuser_data.dealercode = fetch_data.dealercode;
            loginuser_data.sbu_name = fetch_data.sbu_name;
            loginuser_data.sbucode = fetch_data.sbu;
            loginuser_data.dealer_name = fetch_data.dealer_name;
            loginuser_data.parentInfo = fetch_data.parentInfo;

            _this.$store.commit('updateLoginUser', loginuser_data);
            localStorage.setItem('giant_userdata', JSON.stringify(loginuser_data));

            localStorage.removeItem('giant_userselect');

            _this.selectUserType = false;

            location.reload();

            // location.reload();
          } else if(res.data.status == 2){
            _this.reloginPopup()
          }else {
            _this.$toast(res.data.msg?res.data.msg:'出现了一些问题');
          }
        }else{
          _this.$toast('提交失败');
        }
      }).catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        }else{
          _this.$toast('出现了一些问题');
        }


      })

    },


    //页面滚动
    scrollPage(data){
      const _this = this;

      _this.fixedHeader = data.isFixed;
    },

    //查询我的学分
    getmypoint(){
      const _this = this;

      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey,
        type: '1'
      }

      _this.axios
      .post(
        _this.$store.state.api.gra_api + "my/userScoreInfo",
        _this.qs.stringify(tmpParams)
      )
      .then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("载入学分失败：接口异常");
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 1) {
            
            _this.myPoint = res.data.data.now_score;

          }else if(res.data.status == 2){
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '当前账号已在其他设备登录',
              message: _this.$store.state.browser.giantopoapp?'如需继续操作，返回后请重新打开GRA':'请重新登录',
              showCancelButton: false,
              confirmButtonText: _this.$store.state.browser.giantopoapp?'我知道了':'前往登录',
            }).then(() => {
              if( _this.$store.state.browser.giantopoapp  ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: location.href } })
              }
            }).catch(() => {
            });
          }  else {
            _this.$toast.fail(
              res.data.msg ? res.data.msg : "载入学分失败：出现了一些问题"
            );
          }
        } else {
          _this.$toast.fail("载入学分失败：网络加载失败，请稍候再试");
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        }else{
          _this.$toast.fail("载入学分失败");
        }
       
        console.error(error);
      });
    },

    //查询我的证书
    getmycertificate(){
      const _this = this;

      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey
      }

      _this.axios
      .post(
        _this.$store.state.api.gra_api + "my/myCertificateCount",
        _this.qs.stringify(tmpParams)
      )
      .then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("载入证书数量失败：接口异常");
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 1) {
            
            _this.mycertificate = res.data.data.num;

          }else if(res.data.status == 2){
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '当前账号已在其他设备登录',
              message: _this.$store.state.browser.giantopoapp?'如需继续操作，返回后请重新打开GRA':'请重新登录',
              showCancelButton: false,
              confirmButtonText: _this.$store.state.browser.giantopoapp?'我知道了':'前往登录',
            }).then(() => {
              if( _this.$store.state.browser.giantopoapp  ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: location.href } })
              }
            }).catch(() => {
            });
          } else {
            _this.$toast.fail(
              res.data.msg ? res.data.msg : "载入证书数量失败：出现了一些问题"
            );
          }
        } else {
          _this.$toast.fail("载入证书数量失败：请求失败");
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        }else{
          _this.$toast.fail("载入证书数量失败");
        }
       
        console.error(error);
      });
    },
        //查询我的勋章
    getmyMedal(){
      const _this = this;

      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey,
        type:'1'
      }

      _this.axios
      .post(
        _this.$store.state.api.gra_api + "my/getUserMedal",
        _this.qs.stringify(tmpParams)
      )
      .then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("载入证书数量失败：接口异常");
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 1) {
            
            _this.myMedal = res.data.data.count;

          }else if(res.data.status == 2){
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '当前账号已在其他设备登录',
              message: _this.$store.state.browser.giantopoapp?'如需继续操作，返回后请重新打开GRA':'请重新登录',
              showCancelButton: false,
              confirmButtonText: _this.$store.state.browser.giantopoapp?'我知道了':'前往登录',
            }).then(() => {
              if( _this.$store.state.browser.giantopoapp  ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: location.href }});
              }
            }).catch(() => {
            });
          }  else {
            _this.$toast.fail(
              res.data.msg ? res.data.msg : "载入证书数量失败：出现了一些问题"
            );
          }
        } else {
          _this.$toast.fail("载入证书数量失败：请求失败");
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        }else{
          _this.$toast.fail("载入证书数量失败");
        }
        console.error(error);
      });
    },
    goToMedal(){
      let _this = this;
      // if(_this.myMedal == 0){
      //   return
      // }
      _this.$router.push("/mymedal")
    },
    btn_loginout(){
      const _this = this;

      _this.$dialog.confirm({
        title: '确认退出吗？',
        //message: '您可以尝试：',
        //confirmButtonText: '刷新重试',
        //cancelButtonText: '返回首页'
      }).then(() => {

        localStorage.removeItem('giant_userdata');
        localStorage.removeItem('giant_userselect');

        _this.$store.commit('updateLoginUser', false);

        _this.axios.post(_this.$store.state.api.gra_api + 'login/loginOut/'+_this.$store.state.loginUser.sessionkey).then(function(res){
          //成功
        }).catch(function (error) {
          console.error(error)
        });

        //跳转到首页
        _this.$router.replace({ path: '/'});

      }).catch(() => {
        
      });
    },
   
  }
}
</script>

<style lang="less" scoped>
.userdata_content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 15;
  .mask {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .8;
    z-index: 15;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .userdata_wrap {
    width: 90%;
    max-width: 512px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    z-index: 25;
    .titles {
      font-size: 18px;
      padding-bottom: 20px;
      text-align: center;
    }
    .list_user {
      .item_user {
        display: flex;
        align-items: center;
        padding: 10px 0;
        cursor: pointer;
        .icon {
          flex-shrink: 0;
          color: #34497E;
        }
        .title_wrap {
          color: #34497E;
          padding-left: 10px;
          flex: 1;
          font-size: 14px;
          .badges {
          }
        }
        &.active {
          .icon,
          .title_wrap {
            color: #4E66FF;
          }
        }
      }
    }
    .btn_box {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        width: 48%;
        line-height: 40px;
      }
    }
  }
}
.medal_num_area{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 8px;
  font-size: 14px;
  .medal_icon{

      width: 20px;
      height: 20px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 10px;
      display: inline-block;
    
      margin-right: 8px;
  }
  .arrow{
    margin-left: 4px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/PageMe.vue